import {Property} from "../../../../../models/Property";
import {IconButton, makeStyles, TextField} from "@material-ui/core";
import {Add as AddIcon, Remove} from "@material-ui/icons";
import {CustomInputContainer} from "../../PropertyForm";
import {preventNonDigitSymbolInput, removeLeadingZeros} from "../../../../../utils/functions";
import React from "react";
import styled from "@emotion/styled";

const useStyles = makeStyles((theme) => ({
  hidden: {
    visibility: "hidden",
    userSelect: "none",
  },
  customInput: {
    margin: "0px 5px",
  },
  inputDisabled: {
    color: "rgba(255,255,255,0.5)!important",
  },
}));

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .MuiOutlinedInput-input {
    padding: 10px 15px;
  }
  .MuiTextField-root {
    margin: 0 5px;
  }
`

const CounterInput = (p: {
  value: number;
  index: number;
  handleChangeCounter: (field: string, value: number, index: number) => void;
  property: Property;
}) => {
  const { value, index, handleChangeCounter, property } = p;
  const styles = useStyles();
  const isDisabled = false; // property && property.a11y_standard !== "hotel";
  return (
    <Wrapper>
      <IconButton
        onClick={() => {
          if (value > 0) {
            handleChangeCounter('number_of_units',value - 1, index);
          }
        }}
        size="small"
        disabled={isDisabled}
        className={value > 0 ? "" : styles.hidden}
      >
        <Remove />
      </IconButton>
      <TextField
        name="number_of_units"
        variant="outlined"
        type="number"
        disabled={isDisabled}
        value={removeLeadingZeros(value)}
        onKeyDown={(e) => {
          if (value === 0 && e.key === 'ArrowDown') {
            e.preventDefault()
          }
          preventNonDigitSymbolInput(e)
        }}
        onChange={(e) => {
          handleChangeCounter(
            'number_of_units',
            parseInt(removeLeadingZeros(e.target.value)),
            index
          );
        }}
        className={`${isDisabled ? styles.inputDisabled : ""} ${
          styles.customInput
        }`}
      />
      <IconButton
        size="small"
        disabled={isDisabled}
        onClick={() => handleChangeCounter('number_of_units', value + 1, index)}
      >
        <AddIcon />
      </IconButton>
    </Wrapper>
  );
};

export default CounterInput